import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

export function initCarousels() {
	const motionPreference = window.matchMedia("(prefers-reduced-motion: reduce)");

	document.querySelectorAll("[data-carousel]").forEach((element) => {
		if (element.swiper) return;

		const slides = element.querySelectorAll(".swiper-slide");

		// Une seule slide : aucun slider nécessaire.
		if (slides.length < 2) return;

		// Empêcher le focus clavier dans les slides masquées.
		const updateAccessibility = (swiper) => {
			swiper.slides.forEach((slide, index) => {
				const inactive = index !== swiper.activeIndex;

				slide.inert = inactive;
				slide.setAttribute("aria-hidden", String(inactive));
			});
		};

		const swiper = new Swiper(element, {
			modules: [A11y, Autoplay, EffectFade, Navigation, Pagination],

			autoplay: motionPreference.matches
				? false
				: {
						delay: 4500,
						disableOnInteraction: true,
						pauseOnMouseEnter: true,
					},

			slidesPerView: 1,
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},

			speed: motionPreference.matches ? 0 : 700,
			rewind: true,
			autoHeight: true,

			navigation: {
				prevEl: element.querySelector(".o-carousel_prev"),
				nextEl: element.querySelector(".o-carousel_next"),
			},

			pagination: {
				el: element.querySelector(".o-carousel_pagination"),
				clickable: true,
			},

			a11y: {
				prevSlideMessage: "Diapositive précédente",
				nextSlideMessage: "Diapositive suivante",
				paginationBulletMessage: "Aller à la diapositive {{index}}",
				slideLabelMessage: "{{index}} sur {{slidesLength}}",
			},

			on: {
				init: updateAccessibility,
				slideChange: updateAccessibility,
			},
		});

		motionPreference.addEventListener("change", (event) => {
			swiper.params.speed = event.matches ? 0 : 700;
		});
	});
}
